import { Outlet } from "react-router-dom"
import { Wrapper } from "../components/UI/Custom/Wrapper"
import styles from "../styles/Layout/Layout.module.css"
import { Sidebar } from "./Sidebar"
import { useContext } from "react"
import { ThemeContext } from "../context/ThemeContext"


export const Layout = ({ isLogin, tabsSelected, setTabsSelected, setIsLogin }) => {

    const { theme } = useContext(ThemeContext);


    const { userData } = isLogin;
    const userRole = userData?.userRole;


    return (

        <div className={`${styles.container} ${theme === 'dark' ? styles.darkContainer : ''}`}>


            <Sidebar
                userRole={userRole}
                userData={userData}
                setIsLogin={setIsLogin}
                tabsSelected={tabsSelected}
                setTabsSelected={setTabsSelected}
            />


            <main className={`${styles.main} ${theme === 'dark' ? styles.darkMain : ''}`}>
                <Wrapper
                    top_bottom={1}
                >
                    <Outlet></Outlet>
                </Wrapper>
            </main>


            <Sidebar
                userRole={userRole}
                userData={userData}
                setIsLogin={setIsLogin}
                tabsSelected={tabsSelected}
                setTabsSelected={setTabsSelected}
            />
        </div>

    )
}